import request from '../config/axios-config';

export function getPapersForUser(page, query) {
    return (
        request({
            method: 'get',
            url: '/paper/' + page + query,
        }))
}

export function getPapersForSigning() {
    return (
        request({
            method: 'get',
            url: '/paper/for-signing'
        }))
}

// expectedOrder: the step acted on; the API answers 409 when another candidate already handled it.
// registrationNumber: required when that step registers the paper.
// infoValues: required at an info step, one value per line of the step; infoLabels: the lines shown.
export function approve(paperId, approve, motivation, deletedArticlesIds, articles, expectedOrder, registrationNumber, infoValues, infoLabels) {
    return (
        request({
            method: 'post',
            url: '/paper/approve',
            data: {
                paperId: paperId,
                approve: approve,
                motivation: motivation,
                deletedArticlesIds: deletedArticlesIds,
                articles: approve ? articles : null,
                expectedOrder: expectedOrder,
                registrationNumber: registrationNumber,
                infoValues: infoValues,
                infoLabels: infoLabels
            }
        }))
}

export function addPaper(body) {
    return (
        request({
            url: "/paper/add",
            method: 'post',
            data: body
        }))
}